import { CSSProperties } from "react";
import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_INLINE_LABEL_SEPARATOR,
  NOTE_PREVIEW_LABELS,
  NOTE_PREVIEW_MUTED_COLOR,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import { NotePreviewPharmacy } from "../note-preview-types";

export interface ReportPharmacyCardProps {
  pharmacy: NotePreviewPharmacy;
  style?: CSSProperties;
}

const lineStyle: CSSProperties = {
  margin: "2px 0 0",
  fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  lineHeight: 1.5,
  color: NOTE_PREVIEW_TEXT_COLOR,
  breakInside: "avoid",
};

const Row = ({ label, value }: { label: string; value?: string }) =>
  value ? (
    <p style={lineStyle}>
      <span style={{ color: NOTE_PREVIEW_MUTED_COLOR }}>
        {label}
        {NOTE_PREVIEW_INLINE_LABEL_SEPARATOR}
      </span>
      {value}
    </p>
  ) : null;

/** Pharmacy name in bold with phone, fax and address on their own labelled lines. */
const ReportPharmacyCard = ({ pharmacy, style }: ReportPharmacyCardProps) => (
  <div style={{ marginBottom: 8, ...style }}>
    <div style={{ ...lineStyle, fontWeight: 600, breakAfter: "avoid" }}>
      {pharmacy.name}
    </div>
    <Row label={NOTE_PREVIEW_LABELS.pharmacyPhone} value={pharmacy.phone} />
    <Row label={NOTE_PREVIEW_LABELS.pharmacyFax} value={pharmacy.fax} />
    <Row label={NOTE_PREVIEW_LABELS.pharmacyAddress} value={pharmacy.address} />
  </div>
);

export default ReportPharmacyCard;
